/* eslint-disable import/prefer-default-export */

export const setFirstLetterUppercase = (value) => {
  if (!value) return '';
  return (`${value.charAt(0).toUpperCase()}${value.slice(1)}`);
};
